import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { makeSelectPermission } from 'app-redux/selectors'

/**
 *
 * @param {object} props
 * @param {string} props.resource
 * @param {boolean=} props.recursive
 * @returns {*}
 */
const useMemoizePermissions = ({ resource, recursive }) => {
  const selectPermissions = useMemo(makeSelectPermission, [])
  const permissions = useSelector((state) => selectPermissions(state, resource, recursive))
  return permissions
}

export default useMemoizePermissions
